import StandingsBase from "./StandingsBase";

export default function StandingsInt() {
    return (
        <StandingsBase
            scopeType="DRIVER"
            classKey="INT"
            heading="Meisterschaftswertung"
            pillLabel="INT"
        />
    );
}
